import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAppAuthContext } from "../../context/AuthContext";
import { theme } from "../../theme";
import { SUPPORT_URL } from "../../utils/constants";

export const SettingsMenu: React.FC<{
  anchorEl: HTMLElement | null;
  handleMenuClose: () => void;
}> = (props) => {
  const open = Boolean(props.anchorEl);
  const authContext = useAppAuthContext();

  const handleGetHelpBtnClick = () => {
    window.open(SUPPORT_URL);
    props.handleMenuClose();
  };

  const handleLogoutBtnClick = () => {
    props.handleMenuClose();
    authContext.appSignOut();
  };

  return (
    <Menu
      anchorEl={props.anchorEl}
      open={open}
      onClose={props.handleMenuClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: theme.palette.secondary.main,
        },
      }}
    >
      {/* This should be uncommented when the User Guide is completed */}
      {/* <MenuItem sx={{ paddingRight: 6 }}>
        <ListItemIcon>
          <DescriptionIcon fontSize="small" sx={{ color: theme.palette.text.primary }} />
        </ListItemIcon>
        <ListItemText>User Guide</ListItemText>
      </MenuItem> */}
      <MenuItem onClick={handleGetHelpBtnClick} sx={{ paddingRight: 6 }}>
        <ListItemIcon>
          <HelpIcon fontSize="small" sx={{ color: theme.palette.text.primary }} />
        </ListItemIcon>
        <ListItemText>Get Help</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogoutBtnClick}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" sx={{ color: theme.palette.text.primary }} />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </Menu>
  );
};
